/**
 * @file Lang-header.tsx
 * @module LangHeader
 * @description Axios pieprasījuma interceptors, kas pievieno Accept-Language galveni
 *              pēc pašreizējā i18next valodas iestatījuma. Nodrošina, ka ĢIS datu
 *              serviss atgriež lokalizētas atbildes (lauku nosaukumi, klasifikatoru vērtības).
 */

import axios from "axios";
import i18next from "i18next";
import { useEffect } from "react";

/**
 * Determines the active language from the URL query parameter.
 * @returns "en" if lang=en is in the URL, otherwise "lv" (Latvian default)
 */
export function getLang() {
	const url = window.location.href;
	if (url.includes("lang=en")) {
		return "en";
	}
	if (url.includes("lang=lv")) {
		return "lv";
	}
	return "lv";
}

/**
 * Headless component that registers the Accept-Language Axios interceptor on mount.
 * Ensures all API requests include the correct language header and syncs i18next.
 */
export const LangHeader = () => {
	useEffect(() => {
		const lang = getLang();
		if (!!lang)
			axios.interceptors.request.use(
				(config) => {
					if (i18next.resolvedLanguage !== lang) i18next.changeLanguage(lang);
					config.headers["Accept-Language"] = lang;
					return config;
				},
				(error) => {
					Promise.reject(error);
				}
			);
	}, []);

	return <></>;
};
